import { useState } from 'react';

export const SnackbarState = () => {
    const [alert, setAlert] = useState({ isOpen: false, textBody: ""})

    return {
        alertVal: {data: alert, set: setAlert}
    }
}